import { useQuery } from '@tanstack/react-query'

import { CartViewModel } from '@/types/api'

import fetchRequest from './fetch-request'

import { CartReactQueryKeys } from '../(order)/cart/types'

export default function useCartData() {
    const { data, isFetching, isLoading, refetch } = useQuery<CartViewModel>({
        queryKey: [CartReactQueryKeys.MyCart],
        refetchOnMount: false,
        retryOnMount: false,
        staleTime: 0,
        queryFn: () => {
            return fetchRequest({ serviceName: 'ntl', endpoint: '/carts/_my', method: 'GET' })
        },
    })

    return {
        cart: data,
        isLoading: isLoading,
        isAuditing: isFetching,
        auditCart: refetch,
    }
}
